import './header.scss';
import HeaderBtns from './HeaderBtns';
import HeaderMenu from './HeaderMenu';

function Header() {
   return (
      <header className = "header">
         <div className = "header__wrapper">
            <div className = "header__block-up">
               <a href="https://www.monitoraudio.com/"><img  className="pic_MONITOR" src= "/img/monitor.svg" alt= "MONITOR AUDIO"></img></a>
               <a href="https://www.pult.ru/"><img className="pic_logo" src= "/img/logo1.svg" alt= ""></img></a>
            </div>
            <HeaderMenu />
            <HeaderBtns />
         </div>
      </header>
   )
}
export default Header;